import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import type { SessionUser } from "@resume-cloudflare/shared";
import { api, ApiError } from "./api";

async function fetchSession(): Promise<SessionUser | null> {
  try {
    return await api<SessionUser>("/api/me");
  } catch (err) {
    if (err instanceof ApiError && err.status === 401) return null;
    throw err;
  }
}

export function useSession() {
  return useQuery({
    queryKey: ["session"],
    queryFn: fetchSession,
    staleTime: 30_000,
    retry: false,
  });
}

export function useSignOut() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api<{ ok: boolean }>("/auth/logout", { method: "POST" }),
    onSuccess: () => {
      qc.setQueryData(["session"], null);
    },
  });
}
